// This is the JS to toggle between grid and list view for the collection page

import { setCookie } from './utils';

document.addEventListener('DOMContentLoaded', () => {
  const viewToggleContainer = document.querySelector('.archive__view');
  const collectionWrapper = document.querySelector('.archive-grid');

  if (!viewToggleContainer || !collectionWrapper) {
    return;
  }

  function setMobileViewMode(mode: string) {
    // Add list-view class to container if enabling list view
    collectionWrapper?.classList.toggle('archive-grid--list-view', mode === 'list');

    // Only set cookie if consented (Termly groups "performance and functionality" together...)
    if (window.Termly?.getConsentState().performance) {
      setCookie('mobileViewMode', mode, 365);
    }
  }

  // Hook up event listeners
  const radios = document.querySelectorAll('.archive__view input[type="radio"]');
  radios.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      setMobileViewMode(target.value);
    });
  });
});
